let initialState={payload:{msg:'fetching',data:[]},action:"success"};
let CustomersInspection =(state=initialState.payload,action)=>{
    switch(action.type){
        case "success":{
                state={
                data:action.payload,
                msg:'fetched'
            };
            break;
        }
        default:{}

    }
return state;
}

export default CustomersInspection;


// WEBPACK FOOTER //
// ./src/redux/reducers/customers/customerInspection.js